export const OPEN_SIDEPANEL_TRIGGER_CSS_CLASS = 'scribe-extension-record-trigger';
export const DEFAULT_RECORDING_TAB_URL = 'https://google.com';
export const CANT_BLUR_WITH_AUDIO_RECORDING = `Smart Blur cannot be used while voice transcription is enabled.`;
export const MIN_VERSION_TO_USE_SIDEPANEL = 117;

export const EXTENSION_IDS = {
  chrome: {
    development: 'akdgellphoknnmpkkhieabhhjkpdpcnd',
    staging: 'mcggpfcklgdeapebnjaegopobcgbphnc',
    production: 'okfkdaglfjjjfefdcppliegebpoegaii',
    hosteddevelop: 'hneddommojmjominlnaidhgioblbhief',
  },
  edge: {
    development: 'akdgellphoknnmpkkhieabhhjkpdpcnd',
    staging: 'mcggpfcklgdeapebnjaegopobcgbphnc',
    production: 'ejommccbnocgekjphflienmbmkallcef',
    hosteddevelop: 'hneddommojmjominlnaidhgioblbhief',
  },
};

export * from './topScribeApps';
